import {
  CLEAR_VISUALIZACION,
  DESCARGAR_FORMULARIO_PRESENTADO,
  GET_ESTABLECIMIENTOS_TIPO_O,
  GET_ESTADO_CUMPLIMIENTO_ESTABLECIMIENTOS,
  GET_FORMULARIO_CANCERIGENOS,
  GET_FORMULARIOS_PREVENCION_ESTABLECIMIENTO,
  POST_FORMULARIO_RAR_FIRMADO,
  POST_FORMULARIO_RGRL_FIRMADO,
  VISUALIZAR_CERTIFICADO_PRESENTACION,
  VISUALIZAR_FORMULARIO_PRESENTADO
} from "../actions/establecimiento";

const INITIAL_STATE = {
  estadoCumplimiento: {
    loading: false,
    error: false,
    data: [],
  },
  getFormularioPdf: {
    loading: false,
    error: false,
    data: {},
  },
  getCertificadoPresentacion: {
    loading: false,
    error: false,
    data: {},
  },
  descargarFormularioPdf: {
    loading: false,
    error: false,
    data: {},
  },
  formularioFirmadoAdjunto: {
    loading: false,
    error: false,
    data: {},
  },
  formulariosPrevencion: {
    loading: false,
    error: false,
    data: [],
  },
  establecimientosTipoO: {
    loading: false,
    error: false,
    data: [],
  },
  viewFile: null,
};

const establecimiento = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${GET_ESTABLECIMIENTOS_TIPO_O}_PENDING`:
      return {
        ...state,
        establecimientosTipoO: {
          ...state.establecimientosTipoO,
          error: false,
          loading: true,
        },
      };
    case `${GET_ESTABLECIMIENTOS_TIPO_O}_REJECTED`:
      return {
        ...state,
        establecimientosTipoO: {
          ...state.establecimientosTipoO,
          error: true,
          loading: false,
        },
      };
    case `${GET_ESTABLECIMIENTOS_TIPO_O}_FULFILLED`:
      return {
        ...state,
        establecimientosTipoO: {
          ...state.establecimientosTipoO,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${GET_ESTADO_CUMPLIMIENTO_ESTABLECIMIENTOS}_PENDING`:
      return {
        ...state,
        estadoCumplimiento: {
          ...state.estadoCumplimiento,
          error: false,
          loading: true,
        },
      };
    case `${GET_ESTADO_CUMPLIMIENTO_ESTABLECIMIENTOS}_REJECTED`:
      return {
        ...state,
        estadoCumplimiento: {
          ...state.estadoCumplimiento,
          error: true,
          loading: false,
        },
      };
    case `${GET_ESTADO_CUMPLIMIENTO_ESTABLECIMIENTOS}_FULFILLED`:
      return {
        ...state,
        estadoCumplimiento: {
          ...state.estadoCumplimiento,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${GET_FORMULARIOS_PREVENCION_ESTABLECIMIENTO}_PENDING`:
      return {
        ...state,
        formulariosPrevencion: {
          ...state.formulariosPrevencion,
          error: false,
          loading: true,
        },
      };
    case `${GET_FORMULARIOS_PREVENCION_ESTABLECIMIENTO}_REJECTED`:
      return {
        ...state,
        formulariosPrevencion: {
          ...state.formulariosPrevencion,
          error: true,
          loading: false,
        },
      };
    case `${GET_FORMULARIOS_PREVENCION_ESTABLECIMIENTO}_FULFILLED`:
      return {
        ...state,
        formulariosPrevencion: {
          ...state.formulariosPrevencion,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${DESCARGAR_FORMULARIO_PRESENTADO}_PENDING`:
      return {
        ...state,
        descargarFormularioPdf: {
          ...state.descargarFormularioPdf,
          error: false,
          loading: true,
        },
      };
    case `${DESCARGAR_FORMULARIO_PRESENTADO}_REJECTED`:
      return {
        ...state,
        descargarFormularioPdf: {
          ...state.descargarFormularioPdf,
          error: true,
          loading: false,
        },
      };
    case `${DESCARGAR_FORMULARIO_PRESENTADO}_FULFILLED`:
      return {
        ...state,
        descargarFormularioPdf: {
          ...state.descargarFormularioPdf,
          error: false,
          loading: false,
          data: action.payload,
        },
      };
    case `${VISUALIZAR_FORMULARIO_PRESENTADO}_PENDING`:
      return {
        ...state,
        getFormularioPdf: {
          ...state.getFormularioPdf,
          error: false,
          loading: true,
        },
      };
    case `${VISUALIZAR_FORMULARIO_PRESENTADO}_REJECTED`:
      return {
        ...state,
        getFormularioPdf: {
          ...state.getFormularioPdf,
          error: true,
          loading: false,
        },
      };
    case `${VISUALIZAR_FORMULARIO_PRESENTADO}_FULFILLED`:
      return {
        ...state,
        getFormularioPdf: {
          ...state.getFormularioPdf,
          error: false,
          loading: false,
          data: action.payload.data,
        },
        viewFile: action.payload.data,
      };
    case `${VISUALIZAR_CERTIFICADO_PRESENTACION}_PENDING`:
      return {
        ...state,
        getCertificadoPresentacion: {
          ...state.getCertificadoPresentacion,
          error: false,
          loading: true,
        },
      };
    case `${VISUALIZAR_CERTIFICADO_PRESENTACION}_REJECTED`:
      return {
        ...state,
        getCertificadoPresentacion: {
          ...state.getCertificadoPresentacion,
          error: true,
          loading: false,
        },
      };
    case `${VISUALIZAR_CERTIFICADO_PRESENTACION}_FULFILLED`:
      return {
        ...state,
        getCertificadoPresentacion: {
          ...state.getCertificadoPresentacion,
          error: false,
          loading: false,
          data: action.payload.data,
        },
        viewFile: action.payload.data,
      };

    case `${GET_FORMULARIO_CANCERIGENOS}_PENDING`:
      return {
        ...state,
        getFormularioPdf: {
          ...state.getFormularioPdf,
          error: false,
          loading: true,
        },
      };
    case `${GET_FORMULARIO_CANCERIGENOS}_REJECTED`:
      return {
        ...state,
        getFormularioPdf: {
          ...state.getFormularioPdf,
          error: true,
          loading: false,
        },
      };
    case `${GET_FORMULARIO_CANCERIGENOS}_FULFILLED`:
      return {
        ...state,
        getFormularioPdf: {
          ...state.getFormularioPdf,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${POST_FORMULARIO_RAR_FIRMADO}_PENDING`:
      return {
        ...state,
        formularioFirmadoAdjunto: {
          ...state.formularioFirmadoAdjunto,
          error: false,
          loading: true,
        },
      };
    case `${POST_FORMULARIO_RAR_FIRMADO}_REJECTED`:
      return {
        ...state,
        formularioFirmadoAdjunto: {
          ...state.formularioFirmadoAdjunto,
          error: true,
          loading: false,
        },
      };
    case `${POST_FORMULARIO_RAR_FIRMADO}_FULFILLED`:
      return {
        ...state,
        formularioFirmadoAdjunto: {
          ...state.formularioFirmadoAdjunto,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${POST_FORMULARIO_RGRL_FIRMADO}_PENDING`:
      return {
        ...state,
        formularioFirmadoAdjunto: {
          ...state.formularioFirmadoAdjunto,
          error: false,
          loading: true,
        },
      };
    case `${POST_FORMULARIO_RGRL_FIRMADO}_REJECTED`:
      return {
        ...state,
        formularioFirmadoAdjunto: {
          ...state.formularioFirmadoAdjunto,
          error: true,
          loading: false,
        },
      };
    case `${POST_FORMULARIO_RGRL_FIRMADO}_FULFILLED`:
      return {
        ...state,
        formularioFirmadoAdjunto: {
          ...state.formularioFirmadoAdjunto,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };

    case CLEAR_VISUALIZACION:
      return {
        ...state,
        getFormularioPdf: {
          loading: false,
          error: false,
          data: {},
        },
        getCertificadoPresentacion: {
          loading: false,
          error: false,
          data: {},
        },
        viewFile: null,
      };

    default:
      return state;
  }
};

export default establecimiento;
